"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'deviceOrder',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default
  },
  data: function data() {
    return {
      form: {},
      tableMaxH: '250',
      list: [],
      listLoading: true,
      listQuery: {
        page_num: 1,
        limit: 20,
        search_user_type: 0
      },
      // 订单详情
      order: {},
      detailDialog: false
    };
  },
  computed: {
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    },
    device: function device() {
      return this.$store.state.app.device;
    },
    siteInfo: function siteInfo() {
      return this.$store.getters.siteInfo;
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getList();
    },
    /**
     * 获取列表数据
     */
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, this.form, {
        start: this.listQuery.start - 1
      });
      this.$get('agentapi/goods/query_orders', listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
        if (listQuery.start == 0) _this.tableMaxH = window.innerHeight - _this.$refs.equip_table.$el.offsetTop - 85;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 查询订单详情
     */
    getOrderDetail: function getOrderDetail(row) {
      var _this2 = this;
      this.$get('wxapi/cart/order_detail', {
        buy_id: row.id
      }).then(function (res) {
        _this2.order = res;
        _this2.detailDialog = true;
      });
    }
  }
};